import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { listProductPrice } from 'services/apiProductPricing'

const useListProductPricing = (page,size,searchTerm) => {
  
    const{isPending,isSuccess,isError,error,data} = useQuery({
        queryKey:['priceList',page,size,searchTerm],
        queryFn: ()=> listProductPrice(page,size,searchTerm),
        // keepPreviousData:true,
        staleTime: 2 * 60 * 60 * 1000

    })

    return {isPending,isSuccess,isError,error,data}
}

export default useListProductPricing
